import React from 'react'
import { BoxProps, Flex, Stack, Text } from '../../../vanilla';
import LoadingOverlay from '../../../components/loading-overlay';
import { PAYMENT_METHOD_IDS } from '../../../utils/constants';
import { KlarnaPaymentsButton } from './klarna-payment-button';
import { ClearpayPaymentsButton } from './clearpay-payment-button';

interface PaymentMethodButtonProps extends BoxProps<React.ElementType> {
  containerId: string
  disabled?: boolean
  isLoading: boolean
}

export const PaymentMethodButton = ({ containerId, isLoading, disabled = false, ...rest }: PaymentMethodButtonProps) => {
  const isApplePay = containerId.startsWith(PAYMENT_METHOD_IDS.APPLE_PAY)
  const isDisabled = !isLoading && disabled
  const isKlarna = containerId.startsWith(PAYMENT_METHOD_IDS.KLARNA)
  const isClearpay = containerId.startsWith(PAYMENT_METHOD_IDS.CLEARPAY)

  return (
    <>
      {isDisabled && <Text color={'error'} display={rest.display}>Payment Method Currently Unavailable</Text>}
      {isKlarna ? (
        <Stack id={containerId}>
          <KlarnaPaymentsButton
            opacity={isDisabled ? '0.5' : '1'}
            pointerEvents={isDisabled ? 'none' : 'all'}
            {...rest}
          />
        </Stack>
      ) : isClearpay ? <ClearpayPaymentsButton id={containerId} opacity={isDisabled ? '0.5' : '1'} pointerEvents={isDisabled ? 'none' : 'all'} {...rest} /> : (
        <Flex
          id={containerId}
          data-test-selector={`${containerId}-button`}
          style={{ width: '100%', height: 44 }}
          position="relative"
          align="center"
          borderRadius="base"
          opacity={isDisabled ? '0.5' : '1'}
          pointerEvents={isDisabled ? 'none' : 'all'}
          {...rest}
        >
          {isApplePay && (
            <apple-pay-button
              buttonstyle="black"
              type="pay"
              locale="en-gb"
              style={{ width: '100%', height: '44px' }}
            ></apple-pay-button>
          )}
          <LoadingOverlay
            isLoading={isLoading}
            spinnerSize="sm"
            containerStyles={{ backgroundColor: 'rgba(255, 255, 255, 0.8)' }}
          />
        </Flex>
      )}
    </>
  );
};